import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { updateProfileRequest, updateProfileRequestError, updateProfileRequestSuccess } from "../../slices/Profile/UpdateProfileSlice";


export const UpdateProfileAPI =
    (data) => async (dispatch) => {
        try {
            dispatch(updateProfileRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.updateProfile,
                data: data,
            })
            return dispatch(updateProfileRequestSuccess(response.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(updateProfileRequestError(_error));
        }
    };
